import { Link as FluentLink } from '@fluentui/react-components';

import { TDocument } from '@modules/documents';
import { useExport } from '@modules/documents/api';
import { handlePdfBlob, EHandlePdfBlobMode, getPdfFilename } from '@modules/items';
import { TPermissions } from '@modules/access';

type TProps = {
  doc: TDocument;
  permissions: TPermissions;
};

const PdfReviewWarning = ({ doc, permissions }: TProps) => {
  const exportDoc = useExport();

  const isPdfAvailable = doc.draft?.isPdfUpToDate && doc.draft?.pdfBlobName;

  const handlePreviewPdf = () => {
    const filename = getPdfFilename(doc.name);

    if (isPdfAvailable) {
      handlePdfBlob(doc._id, doc.draft!.pdfBlobName!, permissions.token, EHandlePdfBlobMode.VIEW, filename);
    } else {
      exportDoc.mutate(
        { documentId: doc._id, versionId: 'draft' },
        {
          onSuccess: (data) => {
            if (!data.pdfBlobName) return;
            handlePdfBlob(doc._id, data.pdfBlobName, permissions.token, EHandlePdfBlobMode.DOWNLOAD, filename);
          },
        }
      );
    }
  };

  return (
    <div className="flex space-x-2">
      <p className="font-bold">Please review the PDF layout first:</p>
      <FluentLink onClick={handlePreviewPdf} disabled={exportDoc.isPending}>
        {isPdfAvailable ? 'View PDF' : 'Download PDF'}
      </FluentLink>
    </div>
  );
};

export default PdfReviewWarning;
